export default __webpack_public_path__ + "static/media/Pretendard-Light.40808ea4.woff";